<template>
    <div class="container">
        <div class="row mx-auto mt-5">
          <div class="card-custom">
            <div class="row" style="font-size: 14px;">
              <div class="col-md-2 d-flex border-left my-1" style="position: relative;">
                <div class="row mt-2 w-100">
                  <strong style="text-wrap: nowrap;" class="text-end">زمانبندی :</strong>
                  <div class="text-end pb-3" style="max-width: 100px;float: right;position: absolute;left: 0;top: 32px;">
                    <input type="radio" id="html" name="fav_language" value="HTML" class="ms-1">
                    <label for="html"> ماهانه</label>
                    <br>
                    <input type="radio" id="html" name="fav_language" value="HTML" class="ms-1">
                    <label for="html"> هفتگی</label>
                    <br>
                    <input type="radio" id="html" name="fav_language" value="HTML" class="ms-1">
                    <label for="html"> فصلی</label>
                  </div>
                </div>
              </div>
              <div class="col-md-2 d-flex border-left my-1" style="position: relative;">
                <div class="row mt-2 w-100">
                  <strong style="text-wrap: nowrap;" class="text-end">پوزیشن :</strong>
                  <div class="text-end pb-3" style="max-width: 100px;float: right;position: absolute;left: 0;top: 32px;">
                    <input type="radio" id="html1" name="fav_language1" value="HTML" class="ms-1">
                    <label for="html">خرید</label>
                    <br>
                    <input type="radio" id="html1" name="fav_language1" value="HTML" class="ms-1">
                    <label for="html"> فروش</label>
                  </div>
                </div>
              </div>
              <div class="col-md-2 d-flex border-left my-1" style="position: relative;">
                <div class="row mt-2 w-100">
                  <strong style="text-wrap: nowrap;" class="text-end">میزان سود :</strong>
                  <div class="text-end pb-3" style="max-width: 100px;float: right;position: absolute;left: 0;top: 32px;">
                    <input type="radio" id="html" name="fav_language2" value="HTML" class="ms-1">
                    <label for="html2"> کمترین</label>
                    <br>
                    <input type="radio" id="html" name="fav_language2" value="HTML" class="ms-1">
                    <label for="html2"> بیشترین</label>
                  </div>
                </div>
              </div>
              <div class="col-md-6 d-flex my-2">
                <div class="row my-3 w-100">
                  <strong style="text-wrap: nowrap;" class="text-end">ارز :</strong>
                  <div class="text-end" style="height: 50px;overflow-y: scroll;">
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle11" name="vehicle11" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle12" name="vehicle12" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle13" name="vehicle13" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle14" name="vehicle14" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                    <div class="d-inline-block mx-2">
                      <input type="checkbox" id="vehicle15" name="vehicle15" value="Bike" class="ms-1">
                      <label for="vehicle1">BTCUSDT</label><br>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-auto my-5">
          <table class="table mx-auto table-bordered">
            <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">ارز</th>
                <th scope="col">قیمت ورود</th>
                <th scope="col">حد سود</th>
                <th scope="col">حد ضرر</th>
                <th scope="col">درصد سود</th>
                <th scope="col">عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-success">
                <td class="pt-3">1</td>
                <td class="pt-3">Mark</td>
                <td class="pt-3">Otto</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">
                  <button class="button-table"><FontAwesomeIcon icon="fa-solid fa-eye" /></button>
                </td>
              </tr>
              <tr class="table-danger">
                <td class="pt-3">1</td>
                <td class="pt-3">Mark</td>
                <td class="pt-3">Otto</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">
                  <button class="button-table"><FontAwesomeIcon icon="fa-solid fa-eye" /></button>
                </td>
              </tr>
              <tr class="table-success">
                <td class="pt-3">1</td>
                <td class="pt-3">Mark</td>
                <td class="pt-3">Otto</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">@mdo</td>
                <td class="pt-3">
                  <button class="button-table"><FontAwesomeIcon icon="fa-solid fa-eye" /></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye } from "@fortawesome/free-solid-svg-icons";

export default defineComponent({
  components:{FontAwesomeIcon},
  setup(){
    library.add(faEye)
  }
})

</script>
<style scoped lang="scss">
  .border-left {
    border-left: solid 1px #d3d3d3;
  }

  .card-custom {
    box-shadow: 0px 0px 5px 0px #adadad;
    border: none;
    border-radius: 8px;
  }

  .button-table {
    border: none;
    border-radius: 5px;
    padding: 4px 8px;
    background-color: rgba(255, 255, 255, 0.589);
    color: #0080FF;
    font-size: 18px;
    &:hover {
      background-color: #fff;
    }
  }
</style>